var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIterationCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7587_25592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66656 12.6654C8.66656 9.73203 11.0666 7.33203 13.9999 7.33203C16.9332 7.33203 19.3332 9.73203 19.3332 12.6654C19.3332 15.5987 16.9332 17.9987 13.9999 17.9987H8.66656",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 20.6654L8.66656 17.9987L11.3332 15.332",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4999,
    cy: 13.5,
    r: 11.999,
    stroke: "#292829",
    strokeWidth: 2.002
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7587_25592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.499908 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIterationCircleIcon);
export default __webpack_public_path__ + "static/media/iteration-circle-icon.9aab045c624a9ba2884687e8e76ddac9.svg";
export { ForwardRef as ReactComponent };